import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-esqueleto-tableros',
  templateUrl: './esqueleto-tableros.component.html',
  styleUrl: './esqueleto-tableros.component.css'
})
export class EsqueletoTablerosComponent {

  @Input() filterWidth = 250;
}
